import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { setCanonical, setMeta } from '../utils/seo';
import { SponsorBanner, AdSensePlaceholder } from './AdSlots';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogSection() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    setCanonical('/blog');
    setMeta('Blog - Sizing Tips & Guides', 'Expert sizing tips, brand comparisons, and clothing guides to help you shop smarter online.');
    axios.get(`${API}/blogs`).then(r => setBlogs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-12">
      <div className="mb-10">
        <p className="text-xs font-semibold tracking-widest uppercase text-[#C5A028] mb-2">Latest Articles</p>
        <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tighter text-[#1C1917]">Sizing Tips & Guides</h1>
      </div>
      {blogs.length === 0 ? (
        <p className="text-[#78716C] text-center py-12">No articles yet. Check back soon!</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map(b => (
            <Link key={b.slug} to={`/blog/${b.slug}`} className="bg-white border border-[#E8E2D9] hover:border-[#C5A028] hover:shadow-md transition-all group" data-testid={`blog-card-${b.slug}`}>
              <div className="p-6">
                <h3 className="font-['Cormorant_Garamond'] text-xl font-semibold text-[#1C1917] group-hover:text-[#C5A028] transition-colors mb-2 line-clamp-2">{b.title}</h3>
                <p className="text-sm text-[#78716C] line-clamp-3 mb-4">{b.excerpt || b.content?.slice(0, 150)}</p>
                <div className="flex items-center justify-between">
                  {b.created_at && <span className="text-xs text-[#78716C] flex items-center gap-1"><Calendar className="w-3 h-3" />{new Date(b.created_at).toLocaleDateString()}</span>}
                  <span className="text-xs font-semibold text-[#C5A028] flex items-center gap-1">Read more <ArrowRight className="w-3 h-3" /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
      <SponsorBanner />
      <AdSensePlaceholder />
    </div>
  );
}
